import React from 'react';
import WebRoundedIcon from '@material-ui/icons/WebRounded';

export function WebIcon() {
  return <WebRoundedIcon style={{marginRight: 2}} fontSize="small" />;
}
